/* =========================================
   ISL LAB - Gallery thumbnails controller
========================================= */

(function () {
  function initGallery(gallery) {
    const thumbs = gallery.querySelectorAll(".isl-thumb");
    const items = gallery.querySelectorAll(".isl-gallery__item");

    if (!thumbs.length || !items.length) return;

    function showMedia(mediaId) {
      items.forEach((el) => {
        const isTarget = el.dataset.mediaId === String(mediaId);
        if (isTarget) {
          el.hidden = false;
          el.classList.add("is-active");
        } else {
          el.hidden = true;
          el.classList.remove("is-active");
        }
      });

      thumbs.forEach((btn) => {
        btn.classList.toggle("is-active", btn.dataset.targetMediaId === String(mediaId));
      });
    }

    gallery.addEventListener("click", (e) => {
      const btn = e.target.closest(".isl-thumb");
      if (!btn) return;
      showMedia(btn.dataset.targetMediaId);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".isl-gallery").forEach(initGallery);
  });
})();